import { useEffect } from 'react';
import { defaultBranding } from '../../config/branding';

function PrivacyTermsPage() {
  useEffect(() => {
    window.location.replace(defaultBranding.privacyUrl);
  }, []);

  return null;
}

export default PrivacyTermsPage;
